import React from "react";
import Widget from "./components/Widget";

const App = (props) => {
  	return (
      	<Widget {...props} />
  	);
};

export default App;